export default [
    {
        path: 'relatorio-plantao',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-relatorio-plantao' */
            '@/views/pronto-atendimento/relatorio-plantao/Index'
        ),
        redirect: 'relatorio-plantao/index',
        children: [
            {
                name: 'pronto-atendimento-relatorio-plantao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-relatorio-plantao' */
                    '@/views/pronto-atendimento/relatorio-plantao/List'
                ),
            },
        ]
    }
]